<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-page-toolbar :title="$t('_menu.notifications')" icon="notifications">
    </v-page-toolbar>

    <v-card>
      <v-card-title>
        <span class="text-h5">{{
          $t("_notifications.createNotification")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-bind:valid="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="title"
                  :rules="titleRules"
                  :placeholder="$t('_notifications.headerEnter')"
                  :label="$t('_notifications.notificationHeader')"
                  required
                  counter
                  maxlength="65"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="text"
                  :rules="textRules"
                  rows="3"
                  :placeholder="$t('_notifications.descEnter')"
                  :label="$t('_notifications.notificationDesc')"
                  required
                  counter
                  maxlength="240"
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- <v-btn color="primary" @click="e1 = 1"> Continue </v-btn>
        <v-btn text> Cancel </v-btn> -->
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-6 pb-5">
        <v-spacer></v-spacer>
        <v-btn
          width="200"
          large
          color="primary"
          @click="validBroadcastMessage"
          v-bind:valid="valid"
          :loading="loading"
        >
          {{ $t("common.send") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      title: "",
      text: "",

      titleRules: [(v) => !!v || this.$t("_notifications.mustHeaderEnter")],
      textRules: [(v) => !!v || this.$t("_notifications.mustDescEnter")],
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: null,
      y: null,
      mode: null,
      timeout: 3000,
      valid: false,
      overlay: true,
      loading: false,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters({ language: "app/language" }),
  },
  created() {
    this.overlay = false;
  },
  methods: {
    async validBroadcastMessage() {
      if (this.$refs.form.validate()) {
        var self = this;
        console.log("brooooooadcccaassstt");
        self.loading = true;
        self.valid = true;
        self
          .$swal({
            title: "Bildirimi göndermek istediğinize emin misiniz?",
            type: "question",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Gönder",
            cancelButtonText: "Vazgeç",
            showCloseButton: true,
            showLoaderOnConfirm: true,
          })
          .then(async function (isConfirm) {
            if (isConfirm.value) {
              try {
                await self.$store.dispatch(
                  "notifications/sendBroadcastMessage",
                  {
                    title: self.title,
                    text: self.text,
                  }
                );
                self.title = "";
                self.text = "";

                self.snackbar = true;
                self.snackColor = "success";
                self.snackText = "Bildirim Gönderildi!";
                self.x = "center";
                self.y = "bottom";
                self.$swal({
                  title: "Bildirim Gönderildi!",
                  type: "success",
                  icon: "success",
                  confirmButtonText: "Tamam",
                });
              } catch (e) {
                self.snackbar = true;
                self.snackColor = "error";
                self.snackText = "Bildirim Gönderilemedi!";
              } finally {
                self.loading = false;
                self.$refs.form.resetValidation();
              }
            } else {
              self.loading = false;
            }
          });
      }
    },
  },
  watch: {
    language: function () {
      console.log("lang changed");
      this.$refs.form.resetValidation();
    },
  },
};
</script>